var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    {
      staticClass: "wizard-steps horizontal-steps rich-steps",
      class: { completed: _vm.completed },
    },
    _vm._l(_vm.steps, function (step, index) {
      return _c(
        "li",
        {
          key: index,
          staticClass: "wizard-step",
          class: {
            active: _vm.currentStep >= index,
            current: _vm.currentStep === index,
          },
          style: { width: 100 / _vm.steps.length + "%" },
        },
        [
          _c("i", { staticClass: "ion ion-md-close step-icon icon-cross" }),
          _c("i", { staticClass: "ion ion-md-checkmark step-icon icon-check" }),
          _c("span", { staticClass: "wizard-step-label ellipsis" }, [
            _vm._v(_vm._s(step.label)),
          ]),
          _c("span", { staticClass: "wizard-step-line" }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }